import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  grid: {
    "& .MuiTableContainer-root": {
      overflowY: "hidden",
    },
  },
  productLengthTitle: {
    color: "#465869",
    fontWeight: 600,
    marginRight: "8px",
  },
  actionExtraIcon: {
    cursor: "pointer",
    marginLeft: "3px",
  },
  quantityDiv: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  quantityInput: {
    maxWidth: "120px",
    "& .MuiOutlinedInput-root": {
      height: "32px",
    },
  },
}));

export default styles;
